/**
 * Cross-boundary chatbot open signal.
 *
 * Lets components rendered inside the page tree (e.g. <ChatbotInlineInput />)
 * ask the chatbot to open with an optional initial message — without needing
 * access to the ChatbotContext. This is what allows the chatbot provider to
 * sit as a sibling of the page body rather than as a wrapper around it, which
 * removes the client boundary that was blocking LCP paint on tenant sites.
 *
 * The bubble component (inside the provider) listens for this event and
 * forwards the payload to `open(initialMessage)`.
 */
export const CHATBOT_OPEN_EVENT = 'webfront:chatbot:open';

export type ChatbotOpenEventDetail = {
  /** Initial message to send when the bubble opens. Optional. */
  initialMessage?: string;
};

/** Fired by anything that wants to open the chatbot. No-op outside the browser. */
export const dispatchChatbotOpen = (detail: ChatbotOpenEventDetail = {}): void => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<ChatbotOpenEventDetail>(CHATBOT_OPEN_EVENT, { detail }),
  );
};
